module.exports = __webpack_public_path__ + "img/Poorter_hotel-421.7a5cba35.jpg";